import { createFileRoute } from '@tanstack/react-router';
import { Suspense, lazy } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { useCatalogExportType } from '~/features/exports/hooks/use-catalog-export-type';
import { useMainScrollReset } from '~/features/exports/hooks/use-main-scroll-reset';

// Explicit dynamic import — see `../exports/$exportId.tsx` for why.
const ProfileRunPage = lazy(() =>
  import('~/features/exports/export-profiles/pages/delivery-run-page').then((m) => ({
    default: m.ProfileRunPage,
  })),
);

/** One export-profile run's page. Ungated — see `../exports/$exportId.tsx`. */
export const Route = createFileRoute('/_authenticated/_tenant/exports/catalog/runs/$runId')({
  component: RouteComponent,
});

function RouteComponent() {
  useCatalogExportType();
  useMainScrollReset();
  const { runId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ProfileRunPage runId={runId} />
    </Suspense>
  );
}
